import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  display: flex;

  flex: 1;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

export const ContainerPhoto = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ContainerInput = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
`

export const ContainerModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
`

export const ContainerDescription = styled.div`
  width: 430px;
  height: 146px;
`

export const Title = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.blue};
  text-align: center;
`

export const Description = styled.p`
  font-size: 14px;
  color: ${colors.grayDark};
  text-align: center;
  line-height: 22.4px;
`

export const ContainerDoc = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-evenly;
`

export const Cnh = styled.img`
  width: 156px;
  height: 203px;
  margin-bottom: 50px;
`

export const Rg = styled.img`
  width: 395px;
  height: 131px;
  margin-bottom: 50px;
`

export const ContainerCenter = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledButton = styled(Button)`
  position: absolute;
  bottom: 20px;

  @media (max-width: 1377px) {
    position: relative;
    bottom: -150px;
  }

  @media (max-height: 668px) {
    bottom: -120px;
  }
`
